<div>
    <form>
        <div id="{{streetNumberID}}">
	        <ng-input [(ng-model)]="addr.streetNumber" id="canadaStreetNumberInput_{{streetNumberID}}"
	            [(ng-error)]="error_streetNumber" 
                  [ng-disable]="notEditable"
	            size="10" max="10" (blur)="onStreetNumber()"
	            alt-text="contact_info_and_mailing_address.streetNumber_alt">
	            {{'contact_info_and_mailing_address.streetNumber'}}</ng-input>
        </div>
        <div id="{{streetNameID}}">
	        <ng-input [(ng-model)]="addr.streetName" id="canadaStreetNameInput_{{streetNameID}}"
	            [(ng-error)]="error_streetName"
                  [ng-disable]="notEditable"
	            size="20" max="60" 
	            alt-text="contact_info_and_mailing_address.streetName_alt">
	            {{'contact_info_and_mailing_address.streetName'}}</ng-input>
        </div>
        <div id="{{unitID}}">
	        <ng-input [(ng-model)]="addr.unit" id="canadaUnitInput_{{unitID}}"
	                  [(ng-error)]="error_unit"
	                  [ng-disable]="addr.chk_unitNA || notEditable" 
	                  size="5" max="5" 
	                  alt-text="contact_info_and_mailing_address.unitNumber_alt">
	                  {{'contact_info_and_mailing_address.unitNumber'}}</ng-input>
        </div>
        <ng-checkbox [(ng-model)]="addr.chk_unitNA" [ng-disable]="notEditable" (change)="addr.unit=''; error_unit = ''">
            {{'contact_info_and_mailing_address.notApplicable'}}</ng-checkbox>

        <div id="{{buzzID}}">
	        <ng-input [(ng-model)]="addr.buzz" id="canadaBuzzInput_{{buzzID}}"
	                  [(ng-error)]="error_buzz" 
	                  [ng-disable]="addr.chk_buzzNA || notEditable" 
	                  size="10" max="10" 
	                  alt-text="contact_info_and_mailing_address.buzzerCode_alt">
	                  {{'contact_info_and_mailing_address.buzzerCode'}}</ng-input>
        </div>
        <ng-checkbox [(ng-model)]="addr.chk_buzzNA" [ng-disable]="notEditable" (change)="addr.buzz=''; error_buzz = ''">
            {{'contact_info_and_mailing_address.notApplicable'}}</ng-checkbox>     
        <div id="{{cityID}}">
	        <ng-input [(ng-model)]="addr.base.city" id="canadaCityTownInput_{{cityID}}"
	                  [(ng-error)]="error_city"
                        [ng-disable]="notEditable"
	                  size="20" max="50" 
	                  alt-text="contact_info_and_mailing_address.cityTown_alt">
	                  {{'contact_info_and_mailing_address.cityTown'}}</ng-input>
        </div>
        <div id="{{provinceID}}">
	        <ng-select [item-list]="items.provinceListForAddr" id="canadaProvinceSelect_{{provinceID}}"
	                  [(ng-model)]="addr.base.province" 
	                  [(ng-error)]="error_province" 
                        [ng-disable]="notEditable"
	                  size="18">{{'contact_info_and_mailing_address.province'}}</ng-select>
	    </div>
        <ng-input [(ng-model)]="addr.postalCode" id="canadaPostalCodeInput_{{provinceID}}"
                  [(ng-error)]="error_postal" 
                  [ng-disable]="notEditable"
                  size="7" max="7" 
                  (change) = "error_postal=''"
                  alt-text="contact_info_and_mailing_address.postalCode_alt">
                  {{'contact_info_and_mailing_address.postalCode'}}</ng-input>
        
        <div class="padding-top-1em" id="needSD">
            <ng-radio [item-list]="items.yesNoList" id="{{needSpecialDeliveryID}}"
                            [(ng-model)] ="addr.deliveryNeed" 
                            [(ng-error)]="error_needSpecialDelivery"
                            [ng-disable]="notEditable"
                            (change)="resetSpecialRoute(addr)"
                            hint-text='contact_info_and_mailing_address.deliveryModeExample'>
                            {{'contact_info_and_mailing_address.askDeliveryMode'}}
            </ng-radio>
        </div>

        <div translate [hidden]="addr.deliveryNeed!='Y'"> 
            <h3 id="{{deliveryModeID}}" html='contact_info_and_mailing_address.selectDeliverMode' class="padding-top-1em"></h3>
            <errors [error]="error_selectDeliveryMode"></errors>
            
            <!-- SS -->
            <ng-radio1 value="SS" [(ng-model)]="addr.deliveryMode" label-style="padding-bottom:0.5em"
                       [ng-disable]="notEditable" (change)="addr.deliveryAddr=''" id="specialDelivery_{{deliveryModeID}}_0"
                      [(ng-clear)]="error_selectDeliveryMode">
               <strong translate>{{'contact_info_and_mailing_address.dm_mailbox'}}</strong>
            </ng-radio1>
            <div class="padding-sd-left">
                  <div translate>{{'contact_info_and_mailing_address.dm_mailbox_desc'}}</div>
            </div>
            
            <!--RR-->
            <ng-radio1 value="RR" [(ng-model)]="addr.deliveryMode" label-style="padding-bottom:0.5em"
                       [(ng-clear)]="error_selectDeliveryMode" [ng-disable]="notEditable" (change)="addr.deliveryAddr=''">
               <strong html='contact_info_and_mailing_address.dm_RR'></strong>
            </ng-radio1>
            <div class="padding-sd-left">
                <div html='contact_info_and_mailing_address.dm_RR_desc'></div>
                <div translate [hidden]="addr.deliveryMode!='RR'">
                    <div class="padding-sd-text-top"><strong html='contact_info_and_mailing_address.rrFieldLabel'></strong></div>
                    <div html='contact_info_and_mailing_address.rrFieldDesc' class="padding-sd-text-bottom"></div>
                    <ng-input inline [(ng-model)]="addr.deliveryAddr" id="ruralRouteInput"
                                [(ng-error)]="error_deliverAddress_RR" 
                                [ng-disable]="notEditable"
                                size="17" max="17" 
                                alt-text="contact_info_and_mailing_address.rrIDInfo_alt">
                            <span [innerHTML]="'contact_info_and_mailing_address.rr'|translate"></span>
                    </ng-input>
                </div>
            </div>

            <!-- MR -->
            <ng-radio1 value="MR" [(ng-model)]="addr.deliveryMode" label-style="padding-bottom:0.5em"
                       [(ng-clear)]="error_selectDeliveryMode" [ng-disable]="notEditable" (change)="addr.deliveryAddr=''">
                <strong html='contact_info_and_mailing_address.dm_MR'></strong>
            </ng-radio1>
            <div class="padding-sd-left">
                <div html='contact_info_and_mailing_address.dm_MR_desc'></div>
                <div translate [hidden]="addr.deliveryMode!='MR'">
                    <div class="padding-sd-text-top">
                        <strong html='contact_info_and_mailing_address.mrFieldLabel'></strong>
                    </div>
                    <div html='contact_info_and_mailing_address.mrFieldDesc' class="padding-sd-text-bottom"></div>
                    <ng-input inline [(ng-model)]="addr.deliveryAddr" id="mobileRouteInput"
                                [(ng-error)]="error_deliverAddress_MR" 
                                [ng-disable]="notEditable"
                                size="17" max="17" 
                                alt-text="contact_info_and_mailing_address.mrInfo_alt">
                        <span [innerHTML]="'contact_info_and_mailing_address.mr'|translate"></span>
                    </ng-input>
                </div>
            </div>

            <!--GD-->
            <ng-radio1 value="GD" [(ng-model)]="addr.deliveryMode"  label-style="padding-bottom:0.5em"
                       [(ng-clear)]="error_selectDeliveryMode" [ng-disable]="notEditable" (change)="addr.deliveryAddr=''">
                <strong html='contact_info_and_mailing_address.dm_GD'></strong>
            </ng-radio1>
            <div class="padding-sd-left">
                <div html='contact_info_and_mailing_address.dm_GD_desc'></div>
                <div translate [hidden]="addr.deliveryMode!='GD'">
                    <div class="padding-sd-text-top">
                        <strong html='contact_info_and_mailing_address.gdFieldLabel'></strong>
                    </div>
                    <div html='contact_info_and_mailing_address.gdFieldDesc' class="padding-sd-text-bottom"></div>
                    <ng-input inline [(ng-model)]="addr.deliveryAddr" id="generalDeliveryInput"
                                [(ng-error)]="error_deliverAddress_GD" 
                                [ng-disable]="notEditable"
                                size="17" max="17" 
                                alt-text="contact_info_and_mailing_address.gdIDInfo_alt">
                            <span [innerHTML]="'contact_info_and_mailing_address.gd'|translate"></span>
                    </ng-input>
                </div>
            </div>

            <!-- it should be 'PO Box'   Not 'POBox' -->
            <ng-radio1 value="PO Box" [(ng-model)]="addr.deliveryMode" label-style="padding-bottom:0.5em"
                       [(ng-clear)]="error_selectDeliveryMode" [ng-disable]="notEditable" (change)="addr.deliveryAddr=''">
                <strong html='contact_info_and_mailing_address.dm_POBox'></strong>
            </ng-radio1>
            <div class="padding-sd-left">
                <div html='contact_info_and_mailing_address.dm_POBox_desc'></div>
                <div translate [hidden]="addr.deliveryMode!='PO Box'">
                    <div class="padding-sd-text-top">
                        <strong html='contact_info_and_mailing_address.poboxFieldLabel' ></strong>
                    </div>
                    <div html='contact_info_and_mailing_address.poboxFieldDesc' class="padding-sd-text-top"></div>
                    <ng-input [(ng-model)]="addr.deliveryAddr" id="postOfficeBoxInput"
                              [(ng-error)]="error_deliverAddress_POBox" 
                              [ng-disable]="notEditable"
                              size="20" max="20" 
                              alt-text="contact_info_and_mailing_address.poboxInfo_alt">
                    </ng-input>
                </div>
            </div>

        </div>
    </form>
</div>
